<template>
  <div
    id="contact-preview"
    class="greedy flex column flex-align-center justify-center">
    <p class="chat-bubble">💬</p>
    <h2>Start a WhatsApp conversation with {{ activeConversation.name ? activeConversation.name : activeConversation.phone | phoneFormat }}</h2>
    <p>Start this conversation by sending a Message Template.</p>
    <div
      class="start-btn flex center-all"
      @click="openSendNotificationModal(true)" >
      <SBIcon
        class="mr-1"
        :icon="SBIconList.WHATSAPP_LOGO_THICK"
        :color="SBColors.bluePrimary"
        :size="14" />
      <p>Send WhatsApp Message Template</p>
    </div>

    <MessageTemplateModal
      ref="messageTemplateModalRef"
      :static-modal="true"
      :business-id="$route.params.businessId"
      @hidden="createNewModalVisible = false"
      @abort="closeModals" />

    <TemplateMissingModal
      :class="{ hide: createNewModalVisible }"
      @create-new-template="createNewTemplate" />
    <NotificationModal
      ref="notificationSendModal"
      :class="{ hide: createNewModalVisible }"
      @create-new-template="createNewTemplate" />
    <NewConversationNotificationModal @start-new-notification="startNewNotification"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import UserDropdownButtonSize from '../../../../helpers/lists/userDropdownButtonSize';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import NotificationModal from '@/components/business/notifications/modals/NotificationModal';
import NewConversationNotificationModal from '@/components/business/notifications/modals/NewConversationNotification.modal';
import TemplateMissingModal from '@/components/business/notifications/modals/TemplateMissing.modal';
import MessageTemplateModal from '@/components/business/settings/modals/MessageTemplate.modal';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'MessagesContactPreview',
  components: {
    NotificationModal,
    NewConversationNotificationModal,
    MessageTemplateModal,
    SBIcon,
    TemplateMissingModal,
  },
  mixins: [
    ToasterMixin,
  ],
  data() {
    return {
      UserDropdownButtonSize,
      createNewModalVisible: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
      userPermissions: 'user/userPermissions',
      currentOrganisation: 'organisation/currentOrganisation',
      templateMessageList: 'notification/templateMessageList',
    }),
  },
  watch: {
    activeConversation() {
      this.$nextTick(() => {
        if (this.activeConversation.openSendNotification) {
          this.openSendNotificationModal();
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.activeConversation.openSendNotification) {
        this.openSendNotificationModal();
      }
    });
  },
  methods: {
    closeModals() {
      this.$refs.notificationSendModal.hide();
    },
    createNewTemplate() {
      const config = {
        backAction: () => {
          this.$refs.messageTemplateModalRef.hide();
        },
        noFade: true,
        forceNew: true,
      };
      this.createNewModalVisible = true;
      this.$refs.messageTemplateModalRef.show(config);
    },
    openSendNotificationModal(setOpenSendNotification = false) {
      if (setOpenSendNotification) {
        this.activeConversation.openSendNotification = true;
      }
      if (this.userPermissions[this.currentOrganisation.id].includes('send_notifications')) {
        if (this.activeConversation && this.activeConversation.id && this.activeConversation.id.startsWith('TEMP')) {
          const name = this.activeConversation.name ? this.activeConversation.name : this.activeConversation.phone;
          if (this.hasApprovedTemplateMessages()) {
            // Uncomment this to get consent modal first
            // const name = this.activeConversation.name ? this.activeConversation.name : this.activeConversation.phone;
            // this.$eventBus.$emit('show-notification-modal', {
            //   phone: name,
            //   businessId: this.activeConversation.businessId,
            //   templateMessageList: { ...this.templateMessageList },
            // });
            this.$refs.notificationSendModal.show();
          } else {
            this.$eventBus.$emit('show-template-missing-modal', name);
          }
        } else if (this.activeConversation && this.activeConversation.id) {
          this.$refs.notificationSendModal.show();
        }
      } else {
        this.showToaster('You don’t have a permission to do this action.', null, null, 'warning');
      }
    },
    hasApprovedTemplateMessages() {
      let hasApprovedTemplates = false;
      if (this.templateMessageList.data.some(templateLang => templateLang.status === 'approved')) {
        hasApprovedTemplates = true;
      }
      return hasApprovedTemplates;
    },
    startNewNotification() {
      this.$refs.notificationSendModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
#contact-preview {
  overflow: hidden;
  margin: 0px;

  h2 {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 500;
    color: $blackPrimary;
  }

  p {
    font-size: 15px;
    font-weight: 400;
    color: $blackUltralight;
    margin-bottom: 35px;
  }

  .chat-bubble {
    font-size: 40px;
    opacity: 0.5;
    margin-bottom: 10px;
  }

  .start-btn {
    border: 1px dashed $bluePrimary;
    border-radius: 5px;
    background-color: $blueExtraLight;
    padding: 9px 18px;
    cursor: pointer;

    p {
      margin-bottom: 0;
      color: $bluePrimary;
    }
  }
}
</style>
